import React from "react";

export default function BsWhatsapp() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.301 5.617A8.836 8.836 0 0 0 11.993 3C7.08 3 3.076 7.003 3.072 11.917a8.95 8.95 0 0 0 1.19 4.46L3 21l4.73-1.24a8.925 8.925 0 0 0 4.263 1.086h.005c4.914 0 8.916-4.003 8.92-8.921A8.886 8.886 0 0 0 18.3 5.617h.001Zm-6.308 13.72A7.394 7.394 0 0 1 8.218 18.3l-.27-.162-2.806.736.75-2.737-.176-.283a7.38 7.38 0 0 1-1.133-3.943c0-4.079 3.326-7.407 7.415-7.407a7.38 7.38 0 0 1 5.242 2.173 7.377 7.377 0 0 1 2.17 5.242c-.005 4.094-3.332 7.416-7.417 7.416Zm4.067-5.552c-.221-.111-1.316-.65-1.522-.726-.205-.073-.354-.112-.5.111-.15.222-.578.727-.706.872-.128.15-.261.166-.484.056-.221-.112-.94-.346-1.79-1.108-.665-.59-1.109-1.322-1.242-1.543-.128-.223-.012-.342.1-.454.097-.099.221-.26.332-.39.113-.127.15-.222.223-.37.073-.151.038-.28-.017-.39-.056-.112-.5-1.211-.688-1.654-.18-.438-.364-.377-.5-.383-.13-.008-.279-.008-.428-.008a.82.82 0 0 0-.596.278c-.204.223-.777.762-.777 1.86 0 1.1.799 2.156.911 2.306.11.15 1.569 2.398 3.806 3.366.529.23.945.367 1.27.47.535.171 1.017.145 1.402.09.428-.065 1.318-.54 1.505-1.06.185-.523.185-.968.129-1.062-.055-.094-.205-.15-.428-.26Z"
        fill="#currentColor"
      />
    </svg>
  );
}
